import { PlayCircleFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { ContentChannelInfos, ContentVideo, ThumbContent, Button, TutorialCardButton } from './styles';

export function CardVideo({ video, isTutorial = false, isSelected = false, handleNewTutorial }: any) {
  const content = (
    <>
      <ThumbContent>
        <img src={video.thumbnail} alt="" />
      </ThumbContent>
      <ContentChannelInfos>
        <h4 title={video.title}>{video.title}</h4>
      </ContentChannelInfos>
      <Button>
        <span className="button"><PlayCircleFilled /> {isSelected ? 'Assistindo agora' : 'Assistir tutorial'}</span>
      </Button>
    </>
  );

  return (
    <ContentVideo>
      {isTutorial ? (
        <TutorialCardButton
          type="button"
          aria-label={`Assistir ${video.title}`}
          aria-pressed={isSelected}
          onClick={() => handleNewTutorial(video)}
        >
          {content}
        </TutorialCardButton>
      ) : (
        <Link to={`/watch/?v=${video.video_id}`} className="link-video">
          {content}
        </Link>
      )}
    </ContentVideo>
  );
}
